/**
 * @param {number}
 * @return {string}
 */
export const secondsToHuman = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds - minutes * 60
  return `${minutes}m ${seconds}s`
}
